/**
 * InventoryManagerContainer - Container Component for InventoryManager
 *
 * Container component responsible for:
 * - Zustand store connection for the global items cache
 * - Accepting passthrough props (items, onChange) from the parent (CharacterSheetTabs)
 * - Delegating presentation to the pure InventoryManager component
 *
 * This follows the Container/Presenter pattern as defined in ADR-034.
 * @see docs/adr/0034-container-presenter-component-pattern.md
 */

import React from 'react';
import { useStore } from '../../hooks/useStore';
import InventoryManager from './InventoryManager';
import type { InventoryManagerPassthroughProps } from './InventoryManager';

const InventoryManagerContainer: React.FC<InventoryManagerPassthroughProps> = (passthroughProps) => {
  // ---------------------------------------------------------------------------
  // Store Connection - Container Responsibility
  // ---------------------------------------------------------------------------
  const allItems = useStore(state => state.session?.cache?.items);

  // ---------------------------------------------------------------------------
  // Render: Delegate to Presenter
  // ---------------------------------------------------------------------------
  return (
    <InventoryManager
      {...passthroughProps}
      allItems={allItems}
    />
  );
};

export default InventoryManagerContainer;
